<template>
  <div class="indexBanner" :option="option">
    <div id="certify" v-if="init">
      <swiper :options="swiperOption" class="swiper-container" v-if="option.length > 1">
        <swiper-slide class="swiper-slide" v-for="(item, index) in option" :key="index">
          <a href="javascript:void(0)"  tag v-if="item.isImge"><img :src="item.picture" :item="JSON.stringify(item)"/></a>
          <template v-else>
            <img :src="item.picture" />
            <div class="videoMask">
              <div class="play" @click="playClick">
                <img :src="play" :href="item.url" :item="JSON.stringify(item)" :type="item.type" :externalLink="item.externalLink"/>
              </div>
              <img class="goBtn" v-if="option[index].externalLink" :src="goBtn" @click="openUrl(option[index])" />
            </div>
          </template>
        </swiper-slide>
      </swiper>
      <template v-else-if="option.length == 1">
        <div class="singleBox" style="">
          <a href="javascript:void(0)" @click="openUrl(option[0])" tag v-if="option[0].isImge"><img :src="option[0].picture"/></a>
          <template v-else>
            <img :src="option[0].picture" class="singleImg" />
            <div class="videoMask">
              <div class="play">
                <img v-if="option[0].url" :src="play" @click="goPlay2(option[0])" :href="option[0].url" :item="JSON.stringify(option[0])" :type="option[0].type" :externalLink="option[0].externalLink"/>
              </div>
              <img class="goBtn" v-if="option[0].externalLink" :src="goBtn" @click="openUrl(option[0])" />
            </div>
          </template>
        </div>
      </template>
    </div>
    <v-video style="width:100%" :isHomeSlider="true" :options="curItem" :externalLink="externalLink" :isShow="isShowV" @callback="callback" :src="videoUrl"></v-video>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import play from '@/assets/homeImages/icon-play.png'
import goBtnCn from '@/assets/homeImages/goBtnCn.png'
import goBtnEn from '@/assets/homeImages/goBtnEn.png'
import vVideo from '@/components/vVideo'

export default {
  props: {
    option: {
      type: [Object, String, Array],
      default: () => ''
    }
  },
  components: {
    vVideo
  },
  computed: {
    ...mapGetters(['language'])
  },
  data() {
    var that = this
    return {
      goBtn: goBtnCn,
      play: play,
      isPlay: true,
      isShowV: false,
      externalLink: '',
      curItem: null,
      videoUrl: '',
      swiperOption: {
        watchSlidesProgress: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        loop: true,
        lazy: {
            loadPrevNext: true
        },
        // loopedSlides: 3,
        speed: 800,
        autoplay: {
          disableOnInteraction: false
          // delay: 20
        },
        on: {
          progress: function() {
            for (let i = 0; i < this.slides.length; i++) {
              const slide = this.slides.eq(i)
              const slideProgress = this.slides[i].progress
              let modify = 1
              if (Math.abs(slideProgress) > 1) {
                modify = (Math.abs(slideProgress) - 1) * 0.4 + 1
              }
              const translate = slideProgress * modify * 718 + 'px'
              const scale = 1 - Math.abs(slideProgress) / 3
              const see = Math.abs(slideProgress) < 2 ? parseInt(slideProgress) : 0
              const zIndex = 3 - Math.abs(Math.round(10 * slideProgress)) + see
              slide.transform(`translateX(${translate}) scale(${scale})`)
              slide.css('zIndex', zIndex)
              slide.css('opacity', 1)
              if (Math.abs(slideProgress) >= 2) {
                slide.css('opacity', 0)
              }
            }
          },
          setTransition: function(transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i)
              slide.transition(transition)
            }
          },
          click: function(e) {
            that.playClick(e)
          }
        }
      },
      init: false
    }
  },
  mounted() {
    setTimeout(() => {
      this.init = true
    }, 100)
    this.goBtn = this.language === 'en' ? goBtnEn : goBtnCn
  },
  methods: {
    playClick(e) {
      let item = e.target.getAttribute('item')
      if (!item) return
      item = JSON.parse(item)
      if (item.isImge) {
        this.openUrl(item)
      } else {
        if (!item.url) return
        window.PC.$RangersEvent("homeCarousel_video_playbutton_Click", {
          video_id: item.index,
          exhibitor_id: item.externalLink
        })
        let url = item.url
        this.goPlay2(item)
        this.commonStatistics('001033000', {url})
      }
    },
    goPlay2(params) {
      this.isShowV = true
      this.videoUrl = params.url
      this.externalLink = params.externalLink
      this.curItem = params
    },

    callback() {
      this.isShowV = false
      this.videoUrl = ''
    },

    openUrl(data) {
      this.commonStatistics('001033000', {url: data.externalLink})
      if (data.type == 'ACTOR' && data.externalLink) {
        this.pageDetail({id: data.externalLink}, 'actor', true, 'video')
      } else if (data.type == 'EXTERNAL' && data.externalLink) {
        window.open(data.externalLink, '_blank')
      }
    }
  },
  created() {}
}
</script>

<style lang="stylus">
.singleBox {
  width: 1000px;
  height: 560px;
  margin: 0 auto;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  object-fit: cover;

  .singleImg {
    height: 100%;
    width: 100%;
    max-width: auto;
  }
  
}
.singleBox .goBtn,
.homeBanner #certify .swiper-slide img.goBtn {
  position: absolute;
  cursor: pointer;
  bottom: 8px;
  right: 15px;
  width: auto;
  height: auto;
}
</style>
